import { api } from "@/api";
import {
  ClearBettingSelectionSuspensionsParams,
  ClearBettingSelectionSuspensionsResponse,
} from "@/types/ApiResponses/BettingSelection";

export const clearBettingSelectionsSuspensions = async (
  params: ClearBettingSelectionSuspensionsParams
): Promise<ClearBettingSelectionSuspensionsResponse> => {
  const res = await api.client.delete(`/betting-selections-new/suspensions`, {
    params,
  });
  return res.data;
};
